import React from 'react';
import JobOpportunityPanel, {
  JobOpportunityType,
} from '@/components/job-opportunity-panel';
import { CityContext } from '@/context/create-context';

const HotJobOpportunity = (props: { data: JobOpportunityType[] }) => {
  const { data } = props;
  const { name } = React.useContext(CityContext);

  if (!Array.isArray(data) || !data.length) {
    return null;
  }

  return (
    <div className="w-full mb-12">
      <h2 className="text-2xl font-semibold mb-5">{name}热招职位</h2>
      <JobOpportunityPanel data={data} />
    </div>
  );
};

export default React.memo(HotJobOpportunity);
